export default __webpack_public_path__ + "images/f35223270c75c46b8fddf6fa91cb1d67.svg";